import { style, animate, transition, query, stagger } from '@angular/animations';

export function fadeIn2(selector = ':enter', duration = '400ms ease-out') {
  return [
    transition('* => *', [
      query(
        selector,
        [
          style({ opacity: 0, transform: 'translateY(-5px)' }),
          stagger('60ms', [
            animate(
              duration,
              style({
                opacity: 1,
                transform: 'translateY(0px)',
              }),
            ),
          ]),
        ],
        { optional: true },
      ),
    ]),
  ];
}

export function fadeIn(duration = 200) {
  return [transition(':enter', [style({ opacity: 0 }), animate(`${duration}ms ease-in`, style({ opacity: 1 }))])];
}

export function fadeOut() {
  return [transition(':leave', [style({ opacity: 1 }), animate('400ms ease-in', style({ opacity: 0 }))])];
}

export function fadeOut2(selector = ':leave', duration = 2000) {
  return [
    transition('* => *', [
      query(
        selector,
        [
          style({ opacity: 1 }),
          stagger('300ms', [
            animate(
              duration,
              style({
                opacity: 0,
              }),
            ),
          ]),
        ],
        { optional: true },
      ),
    ]),
  ];
}
